export const SOCKET_READY_STATE = Object.freeze({
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
});
export const MESSAGE_TYPES = Object.freeze({
    AUTH: 'auth',
    EVENT_ACK: 'event_ack',
});
export const MOBIUS_SOCKET_4001_EVENT = {
    type: 'async_event',
    trackingId: '4001-event',
    eventId: '4001-event-id',
    data: {
        eventType: 'registration.down',
        deviceInfo: {
            userId: '4001-user-id',
            device: {
                deviceId: '4001-device-id',
                uri: '4001-device-uri',
                status: 'inactive',
            },
        },
    },
};
